import { WesService } from 'services/WesService'

export const deleteFavorite = async ({ favoriteId, accessToken }: VP.DTT.Mutations.WorkEntityService.DeleteMutationVariables): Promise<number> =>
  WesService.removeFavorite(favoriteId, accessToken)
